import { useDelay } from 'hooks/useDelay';
import { useCallback, useState } from 'react';

const useDebounce = (value: string, delay: number) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	const debounce = useCallback(() => {
		setDebouncedValue(value);
	}, [value]);

	useDelay(debounce, delay);

	return debouncedValue;
};

export default useDebounce;
